/* eslint-disable @typescript-eslint/no-unused-vars */
import { Field } from '@vtblife/uikit/dist/legacy';
import React, { useCallback } from 'react';
import { createFormikComponent, mapFieldToInputProps } from '@vtblife/uikit-formik';
import { CheckboxComponent, OwnAnswerCheckbox } from '../formik-checkbox-group-field/formik-checkbox-group-field';
const RadioGroupFilteredProps = function (props) {
    // Skip some of params to be passed by Field to RadioGroup
    const { isValid, isError, errorMessage, fullWidth, label, note, hideNoteSpace, options, onChange, value, ownAnswer, ...rest } = props;
    const getCheckboxOnChange = useCallback((value) => (_checked, event) => {
        if (onChange) {
            onChange(value, event);
        }
    }, [onChange]);
    const items = options.map((option, i) => {
        return (React.createElement(CheckboxComponent, { ...rest, key: i, label: option.label, onChange: getCheckboxOnChange(option.value), radio: true, value: value == option.value }));
    });
    return (React.createElement("div", null,
        items,
        ownAnswer && (React.createElement(OwnAnswerCheckbox, { ...rest, key: 'ownAnswer', onTextChange: ({ currentValue, event }) => {
                onChange(currentValue, event);
            }, getCheckboxOnChange: getCheckboxOnChange, getActive: (text) => value === text, radio: true }))));
};
export const RadioGroupField = Field(RadioGroupFilteredProps, false, false);
export const FormikRadioGroupField = createFormikComponent(RadioGroupField, mapFieldToInputProps);
//# sourceMappingURL=formik-radio-group-field.js.map